'use client';

import { FC } from 'react';
import { SlBasket } from 'react-icons/sl';
import { Box, Flex, Text } from '@mantine/core';
import { AppPaths } from '@/configs/appPaths';
import { useQuery } from '@tanstack/react-query';
import CartApi from '@/remoteApi/CartApi';
import { formatPrice } from '@/utilities';
import { useSession } from 'next-auth/react';

interface Props {}

export const CartBox: FC<Props> = () => {
	const { data: sessionData, status } = useSession();

	const cartQuery = useQuery({
		queryFn: CartApi.getUserCart,
		queryKey: [CartApi.queryKey],
		enabled: !!sessionData?.user,
	});

	if (status === 'loading' || !sessionData?.user) {
		return;
	}

	const cart = cartQuery.data;
	const isCartEmpty = !cart || cart?.items?.length === 0;

	return (
		<Box className="hide-on-mobile">
			<Flex
				justify="space-between"
				align="center"
				gap="sm"
				component="a"
				href={`/${AppPaths.ACCOUNT}/${AppPaths.ACCOUNT_CART}`}
				td="none"
			>
				<SlBasket size={24} color="#000" />
				<Box>
					<Text size="sm" c="dark">
						KOSZYK
					</Text>
					<Text size="md" fw="bold">
						{!isCartEmpty
							? formatPrice(
									(cart.totalPrice - (cart.shippingMethod?.price || 0)) / 100
								)
							: '0,00 zł'}
					</Text>
				</Box>
			</Flex>
		</Box>
	);
};
